import appConfig from '@/configs/app.config';
import { REQUEST_HEADER_AUTH_KEY, TOKEN_TYPE } from '@/constants/api.constant';
import axios from 'axios';
import { eventEmitter } from '@/utils/eventEmmiter/eventEmmiter';
import { captureAppMessage } from '@/utils/sentry/sentryLogger';

const BaseService = axios.create({
  timeout: 60000,
  baseURL: appConfig.apiPrefix,
});

BaseService.interceptors.request.use(
  (config) => {
    const tenantId = localStorage.getItem('TENANT_ID');
    const farmId = localStorage.getItem('FARM_ID');
    const accessToken = localStorage.getItem('ACCESS_TOKEN');
    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
    }
    if (tenantId) {
      config.headers['Tenant-Id'] = tenantId;
    }
    if (farmId) {
      config.headers['Farm-Id'] = farmId;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      eventEmitter.emit('TOKEN_EXPIRED');
    }
    if (status === 400) {
      captureAppMessage('API returned 400 Bad Request', 'warning', {
        flow: 'api',
        url: error.config?.url,
        method: error.config?.method,
        tenantId: localStorage.getItem('TENANT_ID') ?? '(missing)',
        farmId: localStorage.getItem('FARM_ID') ?? '(missing)',
        responseData: error.response?.data ? JSON.stringify(error.response.data) : undefined,
      });
    }
    return Promise.reject(error);
  }
);

export default BaseService;
